import { render, staticRenderFns } from "./ScannerType.vue?vue&type=template&id=020ca47f&scoped=true"
import script from "./ScannerType.vue?vue&type=script&lang=js"
export * from "./ScannerType.vue?vue&type=script&lang=js"
import style0 from "./ScannerType.vue?vue&type=style&index=0&id=020ca47f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ca47f",
  null
  
)

export default component.exports